exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,700);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Oswald:300,400,600,700);", ""]);

// module
exports.push([module.id, "body{-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased}.no-select{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.project_type-add-card{position:relative;display:flex;justify-content:center;background-color:#363636;height:35px;overflow:inherit}.project_type-add-card .add-project-save{position:absolute;right:-20px;top:5px;width:16px;height:16px;background-image:url(" + require("../../../../assets/images/save-icon.svg") + ");cursor:pointer}.project_type-add-card .add-project_type-box{border:1px solid #8b8b8b;width:90%;height:24px;background-color:#fff;border-radius:4px}.project_type-add-card .add-project_type-box .project_type-input{margin-top:2px;margin-left:3px;font-family:Open Sans,sans-serif;font-weight:400;font-size:13px;letter-spacing:0;width:95%;border:none;outline:none;text-indent:5px;background-color:transparent}", ""]);

// exports
exports.locals = {
	"addGreen": "#4bb543",
	"inProgress": "#f5a623",
	"complete": "#5db348",
	"iconGrey": "#A4A4A4",
	"warmGreyTwo": "#9b9b9b",
	"gray": "#676767",
	"offBlack": "#2C2C2C",
	"lightElement": "#D8D8D8",
	"white": "#fff",
	"aoDarkBlue": "#184e78",
	"secondaryLabelFont": "#bababa",
	"nonExistant": "#9b9b9b",
	"red": "#D0011B"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/containers/ProjectTemplatesContainer/ProjectTypesNav/ProjectTypeAddCard/ProjectTypeAddCard.scss
// module id = 1795
// module chunks = 0